import { useCallback } from "react";

export const useVoiceInstructions = () => {
  const speak = useCallback((text) => {
    if (typeof window === "undefined" || !window.speechSynthesis) {
      console.log("SpeechSynthesis not supported");
      return;
    }

    // Cancel any current speech
    window.speechSynthesis.cancel();

    const utterance = new SpeechSynthesisUtterance(text);
    utterance.volume = 1;
    utterance.rate = 1;
    utterance.pitch = 1;

    utterance.onstart = () =>
      console.log(`[Audio Event] Started speaking: "${text}"`);
    utterance.onend = () =>
      console.log(`[Audio Event] Finished speaking: "${text}"`);
    utterance.onerror = (event) =>
      console.error(`[Audio Error] Error speaking: "${text}"`, event);

    // Use default voice to avoid dependency on getVoices() loading
    window.speechSynthesis.speak(utterance);
    console.log("[Audio] Requesting speech:", text);
  }, []);

  return { speak };
};
